export const INITIAL_NOTIFICATIONS_RECEIVED = "INITIAL_NOTIFICATIONS_RECEIVED";
export const NOTIFICATION_BATCH_RECEIVED = "NOTIFICATION_BATCH_RECEIVED";
export const NOTIFICATION_RECEIVED = "NOTIFICATION_RECEIVED";
export const NOTIFICATION_REMOVED = "NOTIFICATION_REMOVED";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const CLOSE_NOTIFICATIONS = "CLOSE_NOTIFICATIONS";
export const REOPEN_NOTIFICATION = "REOPEN_NOTIFICATION";
export const REOPEN_NOTIFICATIONS = "REOPEN_NOTIFICATIONS";

export const GET_ARCHIVE_SUCCESS = "GET_ARCHIVE_SUCCESS";
export const GET_ARCHIVE_FAILED = "GET_ARCHIVE_FAILED";
export const DUMP_ARCHIVE = "DUMP_ARCHIVE";
